<template>
    <div class="waterfall-container">
      <div v-for="(item, index) in items" :key="index" :class="'waterfall-item col-' + (index % columnCount)">
        <img :src="item.image" alt="waterfall image" />
        <p>{{ item.text }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "WaterfallP",
    props: {
      items: {
        type: Array,
        default: () => []
      },
      columnCount: {
        type: Number,
        default: 3
      }
    },
    data() {
      return {
        columnHeights: new Array(this.columnCount).fill(0)
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.layoutItems();
      });
    },
    methods: {
      layoutItems() {
        const columns = this.$el.querySelectorAll('.waterfall-item');
        columns.forEach((column) => {
          const minHeightIndex = this.columnHeights.indexOf(Math.min(...this.columnHeights));
          column.style.top = `${this.columnHeights[minHeightIndex]}px`;
          column.style.left = `${(100 / this.columnCount) * minHeightIndex}%`;
          this.columnHeights[minHeightIndex] += column.offsetHeight;
        });
        this.$el.style.height = `${Math.max(...this.columnHeights)}px`;
      }
    }
  };
  </script>
  
  <style scoped>
  .waterfall-container {
    position: relative;
    width: 100%;
    margin: 0 auto;
  }
  
  .waterfall-item {
    position: absolute;
    width: calc(100% / 3 - 10px);
    margin: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    overflow: hidden;
  }
  
  .waterfall-item img {
    width: 100%;
    height: auto;
    display: block;
  }
  
  .waterfall-item p {
    padding: 10px;
    margin: 0;
  }
  </style>